import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";
import "./sidebar.css";
import { useState } from "react";
const Sidebar = () => {
  const { logout } = useAuth();
  const location = useLocation();
  const [isEnquiryOpen, setIsEnquiryOpen] = useState(false);

  const menuItems = [
    { label: "Dashboard", icon: "fa-house", path: "/admin" },

    {
      label: "Enquiry",
      icon: "fa-solid fa-circle-info",
      children: [
        { label: "Job Enquiry", path: "/admin/admin-job-enquiry" },
        { label: "Customer Enquiry", path: "/admin/users" },
      ],
    },
    {
      label: "Project",
      icon: "fa-solid fa-bars-progress",
      children: [
        { label: "Project Category", path: "/admin/project" },
        { label: "Project ", path: "/admin/project-category" },
      ],
    },
    // {
    //   label: "Gallery",
    //   icon: "fa-solid fa-signs-post",
    //   children: [
    //     { label: "Gallery", path: "/admin/gallery" },
    //     { label: "Gallery Category", path: "/admin/gallery-category" },
    //   ],
    // },

    { label: "Blog", icon: "fa-book", path: "/admin/blog" },
    { label: "Career", icon: "fa-solid fa-briefcase", path: "/admin/career" },
    // { label: "Gallery Category", icon: "fa-solid fa-signs-post", path: "/admin/gallery-category" },
    // { label: "Gallery", icon: "fa-solid fa-signs-post", path: "/admin/gallery" },
    { label: "Banner", icon: "fa-solid fa-signs-post", path: "/admin/banner" },
  ];

  const [openMenus, setOpenMenus] = useState({});

  const toggleMenu = (label) => {
    setOpenMenus((prev) => ({
      ...prev,
      [label]: !prev[label],
    }));
  };
  return (
    <div className="custom-sidebar">
      <h4 className="text-center mb-4">Admin Panel</h4>
      <ul className="list-unstyled px-2">
        {menuItems.map((item, index) => {
          const isActive = location.pathname === item.path;
          const isSubActive = item.children?.some(
            (child) => location.pathname === child.path
          );

          return (
            <li
              key={index}
              className={`mb-2 sidebar-item ${
                isSubActive ? "active-link" : ""
              }`}
            >
              {item.children ? (
                <>
                  <div
                    className="d-flex align-items-center justify-content-between sidebar-link"
                    onClick={() => toggleMenu(item.label)}
                    style={{ cursor: "pointer" }}
                  >
                    <div>
                      <i className={`fa-solid me-2 ${item.icon}`}></i>
                      {item.label}
                    </div>
                    <i
                      className={`fa-solid fa-chevron-${
                        openMenus[item.label] ? "up" : "down"
                      }`}
                    ></i>
                  </div>

                  {openMenus[item.label] && (
                    <ul className="submenu list-unstyled ms-4 mt-2">
                      {item.children.map((child, subIndex) => (
                        <li
                          key={subIndex}
                          className={`sidebar-item mb-1 ${
                            location.pathname === child.path
                              ? "active-link"
                              : ""
                          }`}
                        >
                          <Link to={child.path} className="sidebar-link">
                            {child.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </>
              ) : (
                <Link
                  to={item.path}
                  className={`sidebar-link d-flex align-items-center ${
                    isActive ? "active-link" : ""
                  }`}
                >
                  <i className={`fa-solid me-2 ${item.icon}`}></i>
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}

        <li className="mb-3 sidebar-item">
          <Link to="/admin/blog" className="sidebar-link" onClick={logout}>
            <i
              className="fa-solid fa-right-from-bracket me-2"
              style={{ color: "white" }}
            ></i>
            Logout
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
